export default __webpack_public_path__ + "d142c332ffaae006e5da24224f592e6b.png";